import { Component, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { ModelserviceService } from 'src/app/modelservice.service';
import { UploadFileService } from 'src/app/upload-file.service';
import { UserserviceService } from 'src/app/userservice.service';
import { HttpClient } from '@angular/common/http';
import { LoaderService } from 'src/app/loader.service';
import { ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormArray, Validators } from '@angular/forms';
import { translatedData } from 'src/app/dashboard';
import { TranlationService } from 'src/app/tranlation.service';
import Typo from 'typo-js';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { firstValueFrom } from 'rxjs';
import Swal from 'sweetalert2';
import { EditorService } from '../editor.service';

@Component({
    selector: 'app-ocr-srt-edit-page',
    templateUrl: './ocr-srt-edit-page.component.html',
    styleUrls: ['./ocr-srt-edit-page.component.css'],
})
export class OcrSrtEditPageComponent {
    @ViewChild('media') mediaElement!: ElementRef<HTMLVideoElement>;
    private dictionary!: Typo;

    suggestions: string[] = [];

    activeTab: string = 'Summary';
    editData: any;
    fileId: string | null = null;
    fileName: string = 'test';
    selectedSpeaker: string = '';
    videosByCharacter: any;
    speakerVideos: any = [];
    selectedCharacter: string = '';
    uid: any;
    id: any;
    language: any;
    EditData: any;
    Tense: number = 0;
    copyData: any;
    detectedLang: any;
    editFullData: any;
    speaker: string = '[]';
    case: number = 0;
    Punctuation: any;
    dropDown: any;
    customerDetails: any;
    srtJson: any;
    videos = translatedData.videos;
    validLanguages: string[] = [
        'en',
        'hi',
        'zh-CN',
        'ko',
        'es',
        'fr',
        'ja',
        'pt',
        'it',
        'af',
    ];
    transcriptionSections: any;
    originalTranscriptionSections: any;
    newSpeakerName: string = '';
    myForm = this.formBuilder.group({
        inputs: this.formBuilder.array([]),
    });
    quantity: number = 1;
    imageData: File[] = [];
    object: any[] = [];
    isClicked: boolean = false;
    fileData: any;
    mergeJson: any;
    title = translatedData.title;
    isPickerOpen: number | null = null;
    colorOptions: string[] = [
        '#FF9999',
        '#FFB399',
        '#FFE299',
        '#E2FF99',
        '#99FF99',
        '#99FFCF',
        '#99DAFF',
        '#99B6FF',
        '#A599FF',
        '#D699FF',
        '#FF99C5',
        '#E0FFF6',
        '#D8E4D8',
        '#C4E8DF',
    ];
    // List of available speakers for selection
    speakers: any;
    characters: any;
    showCharacterSelect = false;
    generatedSrtLink: string = '';
    constructor(
        private translator: TranlationService,
        private formBuilder: FormBuilder,
        private changeDetector: ChangeDetectorRef,
        private loader: LoaderService,
        private router: Router,
        private route: ActivatedRoute,
        private openModel: ModelserviceService,
        private userService: UserserviceService,
        private uploadfile: UploadFileService,
        private editorService: EditorService,
        private sanitizer: DomSanitizer,
        private http: HttpClient // private spellCheckerService: SpellCheckerService
    ) {}
    videoPresignedUrl: string | null = null;
    characterColors: { [key: string]: string } = {};

    async ngOnInit(): Promise<void> {
        // this.dictionary = new Typo('en_US', undefined, undefined, {
        //     dictionaryPath: 'assets/dictionaries',
        // });

        const affPath = 'assets/dictionaries/en_ZA/en_ZA.aff';
        const dicPath = 'assets/dictionaries/en_ZA/en_ZA.dic';

        const [affData, dicData] = await Promise.all([
            firstValueFrom(this.http.get(affPath, { responseType: 'text' })),
            firstValueFrom(this.http.get(dicPath, { responseType: 'text' })),
        ]);

        // const [affData, dicData] = await Promise.all([
        //     this.http.get(affPath, { responseType: 'text' }).toPromise(),
        //     this.http.get(dicPath, { responseType: 'text' }).toPromise(),
        // ]);

        this.dictionary = new Typo('en_ZA', affData!, dicData!, {
            platform: 'any',
        });

        console.log('hello →', this.dictionary.check('hello')); // should be true
        console.log('helo →', this.dictionary.check('helo')); // should be false

        // this.dictionary = new Typo(
        //     'en_US',
        //     '/assets/dictionaries/en_US.aff',
        //     '/assets/dictionaries/en_US.dic',
        //     { platform: 'any' }
        // );

        // console.log('hello →', this.dictionary.check('hello')); // true
        // console.log('helo →', this.dictionary.check('helo')); // false
        var array_of_suggestions = this.dictionary.suggest('mispeling');
        console.log('array_of_suggestions', array_of_suggestions);

        this.uid = localStorage.getItem('uid')?.toString() || '';
        this.id = localStorage.getItem('currentTitle') || '';
        console.log('User ID:', this.uid);
        console.log('Workspace ID:', this.id);

        // Subscribe to route parameters to get the file ID
        this.route.paramMap.subscribe(async (params) => {
            this.loader.show();
            this.fileId = params.get('fileId');
            console.log('File ID:', this.fileId);

            // Fetch related images data
            this.fetchAllImagesData();

            if (this.fileId) {
                try {
                    // Fetch file data using the service
                    this.fileData = await this.userService.getFileDatas(
                        this.uid,
                        this.id,
                        this.fileId
                    );

                    // File name used for generating srt,stl and vtt files
                    this.fileName = this.fileData.fileName;

                    // console.log('Fetched File Data:', this.fileData);

                    this.videoPresignedUrl =
                        await this.uploadfile.generatePresignedUrl(
                            this.fileData.srtFile.bucketName,
                            this.fileData.videoFile,
                            ''
                        );

                    if (this.mediaElement) {
                        const videoEl = this.mediaElement.nativeElement;
                        videoEl.src = this.videoPresignedUrl || '';
                        videoEl.load();
                    }

                    this.mergeJson = this.fileData.srtFile.path
                        .replace('srtfiles', 'merged-data')
                        .replace(/\.[^/.]+$/, '.json');
                    console.log('jsonPath', this.mergeJson);

                    this.transcriptionSections =
                        await this.uploadfile.getJsonObject(
                            this.fileData.srtFile.bucketName,
                            this.mergeJson
                        );

                    this.generatedSrtLink = `https://${this.fileData.srtFile.bucketName}.s3.amazonaws.com/${this.mergeJson}`;
                    // !CHECK!!!!
                    this.transcriptionSections = this.transcriptionSections.map(
                        (section: any) => ({
                            ...section,
                            speaker: section.speaker || 'Assign Character',
                            processedText: section.text, // start with original text
                        })
                    );

                    this.transcriptionSections.forEach((section: any) => {
                        // 1. Replace "\n" sequences with real line breaks
                        this.ensureCharacterColor(section.speaker);
                        const sentence = (section.text || '').replace(
                            /\\n/g,
                            '\n'
                        );

                        // 2. Split into words + whitespace (preserve spaces and newlines)
                        const tokens = sentence.split(/(\s+)/);

                        // 3. Highlight only real words
                        const highlightedTokens = tokens.map(
                            (token: string) => {
                                // Skip whitespace (spaces, tabs, newlines)
                                if (/^\s+$/.test(token)) {
                                    return token;
                                }

                                const cleaned = token.replace(
                                    /[^\p{L}\p{N}']/gu,
                                    ''
                                );

                                if (!cleaned) return token;

                                const isCorrect =
                                    this.dictionary.check(cleaned);
                                if (!isCorrect) {
                                    // TODO: Store suggestions for potential future use
                                    // const suggestions =
                                    //     this.dictionary.suggest(cleaned);
                                    // console.log('suggestions', suggestions);
                                }
                                return isCorrect
                                    ? token
                                    : `<span class="error">${token}</span>`;
                            }
                        );

                        // 4. Join tokens back (whitespace preserved)
                        section.processedText =
                            this.sanitizer.bypassSecurityTrustHtml(
                                highlightedTokens.join('')
                            );
                    });
                    this.originalTranscriptionSections =
                        this.transcriptionSections;

                    const jsonPath = this.fileData.srtFile.path
                        .replace('srtfiles', 'frontend-data')
                        .replace(/\.[^/.]+$/, '.json');

                    this.videosByCharacter = [];

                    const jsonData = await this.getJSONData(
                        jsonPath,
                        this.fileData.srtFile.bucketName
                    );
                    this.videosByCharacter = jsonData; // Set the JSON data
                    console.log('Videos by character:', this.videosByCharacter);

                    // this.characters = this.extractUniqueCharacters();
                    console.log('characxter. ', this.characters);
                    if (this.characters.length > 0) {
                        this.selectedCharacter = this.characters[0]; // Set the first speaker as default
                        this.onSpeakerChange();
                    }

                    if (this.fileData?.isEdit) {
                        this.EditData = {
                            srtContent: this.fileData.srtContent,
                            language: this.fileData.language,
                            speakerSymbol: this.fileData.speakerSymbol,
                            letterType: this.fileData.letterType,
                            Punctuation: this.fileData.Punctuation,
                            Tense: this.fileData.Tense,
                        };

                        this.language =
                            this.detectedLang || this.EditData.language;
                        if (!this.validLanguages.includes(this.language)) {
                            this.language = 'en'; // Set to English if not present
                        }
                        this.speaker = this.EditData.speakerSymbol;
                        this.case = this.EditData.letterType;
                        this.Punctuation = this.EditData.Punctuation;
                        this.Tense = this.EditData.Tense;
                        this.copyData = this.EditData.srtContent;
                        this.loader.hide();
                    } else {
                        this.language = this.detectedLang || 'en';
                        const editDataInitial = {
                            isEdit: true,
                            srtContent: this.transcriptionSections,
                            language: 'en',
                            speakerSymbol: '[]',
                            letterType: 0,
                            Punctuation: 0,
                            Tense: 0,
                        };
                        await this.updateEditFileData({
                            editDataInitial,
                        });
                        this.EditData = editDataInitial;
                        this.loader.hide();
                    }
                } catch (error) {
                    this.loader.hide();
                    console.error('Error fetching file data:', error);
                }
            } else {
                console.warn('File ID not available, navigating back.');
                this.loader.hide();
                this.back(); // Navigate back to the previous route
            }
            this.adjustHighlightLayerHeight();
        });
    }

    removeTranscriptionSection(index: number) {
        this.transcriptionSections.splice(index, 1);
    }

    toggleCharacterSelect() {
        this.showCharacterSelect = !this.showCharacterSelect;
    }

    addMetadata() {
        this.router.navigate(['/dashboard/metadata']);
    }

    hidePaintColorIcon(speaker: string): boolean {
        const bg = this.characterColors[speaker]?.toLowerCase().trim();
        if (!bg || bg === '#fff' || bg === '#ffffff' || bg === 'transparent')
            return false;
        const colorOptionsLower = this.colorOptions.map((c) => c.toLowerCase());
        return colorOptionsLower.includes(bg);
    }

    togglePicker(index: number, event: MouseEvent) {
        event.stopPropagation();
        this.isPickerOpen = this.isPickerOpen === index ? null : index;
    }

    selectColor(speaker: string, color: string) {
        this.characterColors[speaker] = color;
        this.isPickerOpen = null;
    }

    ensureCharacterColor(speaker: string) {
        if (speaker && !this.characterColors[speaker]) {
            this.characterColors[speaker] = '#FFFF';
        }
    }

    getBackgroundColor(speaker: string): string {
        this.ensureCharacterColor(speaker);

        return this.characterColors[speaker] || '#fff';
    }

    updateCharacterColor(index: number, event: Event) {
        const newSpeaker = (event.target as HTMLSelectElement).value;
        this.transcriptionSections[index].speaker = newSpeaker;
        this.ensureCharacterColor(newSpeaker);
    }

    get characterList(): string[] {
        return Object.keys(this.characterColors);
    }

    onTextChange(index: number, updatedText: string) {
        // update text
        const section = this.transcriptionSections[index];
        section.text = updatedText;
        this.runSpellCheck(section);
        this.syncScroll();
    }

    syncScroll() {
        setTimeout(() => {
            const textareas = document.querySelectorAll('.editor-textarea');
            textareas.forEach((textarea: any) => {
                const wrapper = textarea.closest('.editor-wrapper');
                if (wrapper) {
                    const scrollContainer =
                        wrapper.querySelector('.scroll-container');
                    if (scrollContainer) {
                        scrollContainer.scrollTop = textarea.scrollTop;
                        scrollContainer.scrollLeft = textarea.scrollLeft;
                    }
                }
            });
        });
    }

    textareaScroll(event: Event) {
        const textarea = event.target as HTMLTextAreaElement;
        const wrapper = textarea.closest('.editor-wrapper');
        if (wrapper) {
            const scrollContainer = wrapper.querySelector(
                '.scroll-container'
            ) as HTMLElement;
            if (scrollContainer) {
                scrollContainer.scrollTop = textarea.scrollTop;
                scrollContainer.scrollLeft = textarea.scrollLeft;
            }
        }
    }

    runSpellCheck(section: any) {
        // Normalize "\n" into real newlines
        const sentence = (section.text || '').replace(/\\n/g, '\n');

        // Split into tokens (words + whitespace)
        const tokens = sentence.split(/(\s+)/);

        const highlightedTokens = tokens.map((token: string) => {
            if (/^\s+$/.test(token)) return token;

            const cleaned = token.replace(/[^\p{L}\p{N}']/gu, '');
            if (!cleaned) return token;

            const isCorrect = this.dictionary.check(cleaned);
            return isCorrect ? token : `<span class="error">${token}</span>`;
        });
        console.log('Highighted Tokens', highlightedTokens),
            (section.processedText = this.sanitizer.bypassSecurityTrustHtml(
                highlightedTokens.join('')
            ));

        setTimeout(() => {
            this.adjustHighlightLayerHeight();
        });
    }

    adjustHighlightLayerHeight() {
        const textareas = document.querySelectorAll('.editor-textarea');
        textareas.forEach((textarea: any) => {
            const wrapper = textarea.closest('.editor-wrapper');
            if (wrapper) {
                const highlightLayer = wrapper.querySelector(
                    '.highlight-layer'
                ) as HTMLElement;
                const scrollContainer = wrapper.querySelector(
                    '.scroll-container'
                ) as HTMLElement;

                if (highlightLayer && scrollContainer) {
                    highlightLayer.style.height =
                        scrollContainer.scrollHeight + 'px';
                    highlightLayer.style.minHeight =
                        textarea.scrollHeight + 'px';
                }
            }
        });
    }

    // initialize spell check for all sections
    initiateSpellCheck() {
        this.transcriptionSections.forEach((section: any) =>
            this.runSpellCheck(section)
        );
    }

    extractUniqueCharacters(): string[] {
        const speakers = this.transcriptionSections
            .filter((section: any) => typeof section.speaker === 'string') // Ensure speaker exists and is a string
            .map((section: any) => section.speaker as string); // Explicitly cast to string

        // Cast the Set to a string[] and sort the array
        return Array.from(new Set<string>(speakers)).sort(
            (a: string, b: string) => a.localeCompare(b)
        );
    }

    // Method to change the active tab
    setActiveTab(tabName: string) {
        this.activeTab = tabName;
    }

    // Method to seek the video to a specific time
    seekVideoTo(seconds: number) {
        if (this.mediaElement) {
            this.mediaElement.nativeElement.currentTime = seconds;
            this.mediaElement.nativeElement.play();
        }
    }

    // Method to handle speaker change for a specific section
    updateCharacter(index: number, event: Event) {
        const selectElement = event.target as HTMLSelectElement;
        this.transcriptionSections[index].speaker = selectElement.value;
    }

    // Format time in HH:MM:SS.mmm with consistent leading zeros
    formatTime(seconds: number): string {
        // Handle potential undefined or NaN input
        if (!seconds && seconds !== 0) return '00:00:00.000';

        const h = Math.floor(seconds / 3600);
        const m = Math.floor((seconds % 3600) / 60);
        const s = Math.floor(seconds % 60);
        // Ensure milliseconds are properly rounded to 3 digits
        const ms = Math.round((seconds % 1) * 1000);

        return (
            [
                h.toString().padStart(2, '0'), // Always show hours with leading zero
                m.toString().padStart(2, '0'),
                s.toString().padStart(2, '0'),
            ].join(':') +
            ',' +
            ms.toString().padStart(3, '0')
        );
    }

    back() {
        this.router.navigate(['dashboard/title']);
    }

    onSpeakerChange(): void {
        this.speakerVideos =
            this.videosByCharacter[
                this.selectedSpeaker as keyof typeof this.videosByCharacter
            ] || [];
    }

    replaceSpeakerWithCharacter(): void {
        // Validate that both a speaker and a character are selected
        if (!this.selectedSpeaker || !this.selectedCharacter) {
            this.open({
                header: 'Oops',
                mainContent: 'Please select both a speaker and a character',
                rightButton: 'Ok',
            });
            return;
        }

        // Validate that the selected speaker and character are not the same, unless the selected character is 'Character Unknown'
        if (
            this.selectedSpeaker === this.selectedCharacter &&
            this.selectedCharacter !== 'Assign Character'
        ) {
            this.open({
                header: 'Invalid Selection',
                mainContent:
                    'Selected speaker and character cannot be the same',
                rightButton: 'Ok',
            });
            return;
        }

        // Replace all occurrences of selectedSpeaker with selectedCharacter in transcriptionSections
        this.transcriptionSections.forEach((section: { speaker: string }) => {
            if (section.speaker === this.selectedSpeaker) {
                section.speaker = this.selectedCharacter;
            }
        });

        // Detect changes if necessary (e.g., in case of Angular template binding)
        this.changeDetector.detectChanges();

        console.log(
            `Replaced ${this.selectedSpeaker} with ${this.selectedCharacter} in all applicable sections.`
        );
    }

    //Gets json subtitles

    async getJSONData(jsonPath: string, bucketName: string): Promise<any> {
        try {
            const url = await this.uploadfile.generatePresignedUrl(
                bucketName,
                jsonPath,
                ''
            );
            console.log('[INFO] Pre-signed URL for JSON:', url);

            const jsonData = await this.http
                .get(url, { responseType: 'json' })
                .toPromise();
            if (jsonData) {
                console.log(
                    '[SUCCESS] JSON data fetched successfully:',
                    jsonData
                );
                return jsonData;
            } else {
                throw new Error('JSON data is empty or not found');
            }
        } catch (error) {
            console.error('[ERROR] Failed to fetch JSON data:');
            throw error;
        }
    }

    open(popup: any) {
        this.openModel.openModel(popup);
    }

    async fetchAllImagesData() {
        try {
            const imagesData = await this.userService.getAllImagesData(
                this.uid,
                this.id
            );
            console.log('Fetched Images Data:', imagesData);
            // Use CharacterName instead of Name to ensure we're using character names for subtitles
            this.characters = imagesData
                .map((image) => image.Files.CharacterName || image.Files.Name)
                .filter((name) => name); // Filter out any null/undefined values
            this.characters = ['Assign Character', ...this.characters];
        } catch (error) {
            console.error('Failed to fetch images data:', error);
        }
    }

    async updateEditFileData(data: any) {
        const saveData = JSON.parse(JSON.stringify(data));
        if (saveData.srtContent && Array.isArray(saveData.srtContent)) {
            saveData.srtContent.forEach((section: any) => {
                if (section.processedText) {
                    delete section.processedText;
                }
            });
        }

        const result = await this.userService.updateEditData(
            this.uid,
            this.id,
            this.fileId,
            saveData
        );
        console.log(result, 'data update successfully');
        return;
    }

    detailsMember() {
        if (this.customerDetails.length > 0) {
            const data = this.customerDetails.find(
                (x: any) => x.workspaceId == this.id
            );
            return data;
        }
    }

    getData() {
        this.userService
            .getDetailsData(this.uid)
            .then((result) => {
                this.customerDetails = result.workspaces;
                ``;
            })
            .catch((err) => {
                console.log(err);
            });
    }

    async srtUpdate() {
        this.loader.show();
        try {
            const response = await this.editorService.editorService(
                this.generatedSrtLink,
                this.fileData?.customerName,
                this.transcriptionSections
            );

            return response;
        } catch (error: any) {
            console.log('error', error);
            Swal.fire({
                title: 'Error',
                text: `${error}`,
                confirmButtonText: 'Ok',
                customClass: {
                    title: 'custom-title',
                    popup: 'custom-popup',
                    confirmButton: 'custom-button',
                },
            });
        } finally {
            this.loader.hide();
        }
    }

    async srtGenerate() {
        try {
            const response = await this.editorService.generateSRT(
                this.transcriptionSections
            );
            if (response) {
                this.downloadSrt(response, 'srt');
            }
            return response;
        } catch (error: any) {
            console.log(error);
            Swal.fire({
                title: 'Error',
                text: `${error}`,
                confirmButtonText: 'Ok',
                customClass: {
                    title: 'custom-title',
                    popup: 'custom-popup',
                    confirmButton: 'custom-button',
                },
            });
        }
    }

    async stlGenerate() {
        try {
            const blob = await this.editorService.generateSTL(
                this.transcriptionSections
            );
            if (blob) {
                this.downloadSrt(blob, 'stl');
            }
            return blob;
        } catch (error: any) {
            Swal.fire({
                title: 'Error',
                text: `${error}`,
                confirmButtonText: 'Ok',
                customClass: {
                    title: 'custom-title',
                    popup: 'custom-popup',
                    confirmButton: 'custom-button',
                },
            });
        }
    }

    // async stlGenerate() {
    //     try {
    //         const response = await this.editorService.generateSTL(
    //             this.transcriptionSections
    //         );
    //         if (response) {
    //             this.downloadSrt(response, 'stl');
    //         }
    //         return response;
    //     } catch (error: any) {
    //         Swal.fire({
    //             title: 'Error',
    //             text: `${error}`,
    //             confirmButtonText: 'Ok',
    //             customClass: {
    //                 title: 'custom-title',
    //                 popup: 'custom-popup',
    //                 confirmButton: 'custom-button',
    //             },
    //         });
    //     }
    // }

    async vttGenerate() {
        try {
            const response = await this.editorService.generateVTT(
                this.transcriptionSections
            );
            if (response) {
                this.downloadSrt(response, 'vtt');
            }
            return response;
        } catch (error: any) {
            Swal.fire({
                title: 'Error',
                text: `${error}`,
                confirmButtonText: 'Ok',
                customClass: {
                    title: 'custom-title',
                    popup: 'custom-popup',
                    confirmButton: 'custom-button',
                },
            });
        }
    }
    reset() {
        (this.language = 'en'),
            (this.speaker = '[]'),
            (this.case = 0),
            (this.Punctuation = 0),
            (this.Tense = 0);
        this.onSave();
    }

    get inputs(): FormArray {
        return this.myForm.get('inputs') as FormArray;
    }

    createInputs(event: Event): void {
        const numInputs = (event.target as HTMLInputElement).valueAsNumber || 0;
        this.inputs.clear();
        for (let i = 0; i < numInputs; i++) {
            this.addGroup();
        }
    }

    addGroup(): void {
        const group = this.formBuilder.group({
            name: ['', Validators.required],
            image: [null, Validators.required],
        });
        this.inputs.push(group);
    }

    handleMetadataImage(event: any, index: number): void {
        const files: FileList = event.target.files;
        if (files.length > 0) {
            this.imageData[index] = files[0];
        }
    }

    fileSaveMetaDataID: any;
    async onSubmit(): Promise<void> {
        this.isClicked = true;
        try {
            for (const [index, group] of this.inputs.controls.entries()) {
                const name = group.get('name')?.value;
                const file = this.imageData[index];
                if (file && name) {
                    this.object.push({ name, file });
                }
            }

            console.log('Metadata object to be saved:', this.object);
            this.fileSaveMetaDataID = await this.uploadfile.uploadImage(
                this.object,
                this.uid,
                this.id
            );
            this.closeModal2();
            this.reset();
            this.fetchAllImagesData();
        } catch (error) {
            console.error('Error saving metadata:', error);
        } finally {
            this.isClicked = false;
        }
    }

    resets(): void {
        this.object = [];
        this.quantity = 1;
        this.inputs.clear();
        this.addGroup();
    }

    @ViewChild('modalCloseButton1') modalCloseButton1!: ElementRef;

    closeModal2() {
        const button: any = this.modalCloseButton1.nativeElement;
        button.click();
    }

    addNewSpeaker(): void {
        if (this.newSpeakerName.trim()) {
            // Convert speaker name to uppercase
            const uppercaseName = this.newSpeakerName.trim().toUpperCase();

            // Add the new speaker to the speakers array
            if (!this.speakers.includes(uppercaseName)) {
                this.speakers.push(uppercaseName);
            }

            // Add the new speaker to the characters array (if applicable)
            if (!this.characters.includes(uppercaseName)) {
                this.characters.push(uppercaseName);
            }

            // Sort the arrays alphabetically
            this.speakers.sort((a: string, b: any) => a.localeCompare(b));

            // Reset the input field and close the modal
            this.newSpeakerName = '';
        } else {
            // Show a validation error if no input is provided
            this.open({
                header: 'Oops',
                mainContent: 'Please add speaker name',
                rightButton: 'Ok',
            });
        }
    }

    async onSave() {
        const result = await this.userService.getMemberWorkspace(
            this.uid,
            this.id
        );
        this.dropDown = result;
        if (result == null) {
            const user = await this.detailsMember();
            this.uid = user.userAccessuid;
            this.id = user.workspaceId;
        }
        this.loader.show();
        if (!this.EditData) {
            this.EditData = {
                isEdit: true,
                srtContent: this.transcriptionSections,
                language: this.language || 'en',
                speakerSymbol: this.speaker || '[]',
                letterType: this.case || 0,
                Punctuation: this.Punctuation || 0,
                Tense: this.Tense || 0,
            };
        }

        (this.EditData.language = this.language),
            (this.EditData.speakerSymbol = this.speaker),
            (this.EditData.letterType = this.case),
            (this.EditData.Punctuation = this.Punctuation),
            (this.EditData.Tense = this.Tense);
        const content = JSON.stringify(this.transcriptionSections);
        await this.updateEditFileData(this.EditData);
        const confirm = await this.uploadfile.putJsonObject(
            this.mergeJson,
            this.fileData.srtFile.bucketName,
            content
        );
        this.loader.hide();
    }

    resetSrt() {
        this.transcriptionSections = this.EditData.srtContent;
        (this.language = 'en'),
            (this.speaker = '[]'),
            (this.case = 0),
            (this.Punctuation = 0),
            (this.Tense = 0);
        this.onSave();
    }

    changeCase(event: Event) {
        const selectedValue = (event.target as HTMLSelectElement).value;

        // Parse the selected case value
        const caseType = parseInt(selectedValue, 10);

        // Update transcriptionSections based on case type
        this.transcriptionSections = this.EditData.srtContent.map(
            (section: any) => {
                // Clone the original section to avoid mutating the original data
                const updatedSection = { ...section };

                if (caseType === 1) {
                    // Uppercase case
                    if (updatedSection.text)
                        updatedSection.text = updatedSection.text.toUpperCase();
                    if (updatedSection.sound?.present)
                        updatedSection.sound.present =
                            updatedSection.sound.present.toUpperCase();

                    this.runSpellCheck(updatedSection);
                } else if (caseType === 2) {
                    // Lowercase case
                    if (updatedSection.text)
                        updatedSection.text = updatedSection.text.toLowerCase();
                    if (updatedSection.sound?.present)
                        updatedSection.sound.present =
                            updatedSection.sound.present.toLowerCase();

                    this.runSpellCheck(updatedSection);
                } else {
                    // Normal case, reset to original
                    updatedSection.text = section.text;
                    if (updatedSection.sound?.present)
                        updatedSection.sound.present = section.sound.present;
                    this.runSpellCheck(updatedSection);
                }

                return updatedSection;
            }
        );

        console.log(
            'Updated Transcription Sections:',
            this.transcriptionSections
        );
    }

    changeSpeakerSymbols(event: Event) {
        this.loader.show();
        try {
            this.speaker = (event.target as HTMLInputElement).value;
            // const changeData = this.replaceSymbols(this.srtForm.value.content);
        } catch (err) {
            console.log(err);
        } finally {
            this.loader.hide();
        }
    }

    replaceSymbols(text: string): string {
        // Use temporary placeholders to avoid conflict
        return text
            .replace(/\[/g, '__TEMP_OPEN__')
            .replace(/\]/g, '__TEMP_CLOSE__')
            .replace(/\(/g, '[')
            .replace(/\)/g, ']')
            .replace(/__TEMP_OPEN__/g, '(')
            .replace(/__TEMP_CLOSE__/g, ')');
    }

    generateDialogSheetCSV() {
        let dialogOutput: any[] = [];
        const headers = ['ID', 'Start', 'End', 'Duration', 'Character', 'Text'];
        dialogOutput.push(headers.join(','));
        let counter = 1;
        this.transcriptionSections.forEach((section: any) => {
            const startTime = this.formatTimestamp(section.start);
            const endTime = this.formatTimestamp(section.end);
            const duration = this.formatTime(section.end - section.start);
            // Sound
            // if (section.sound?.present) {
            //     dialogOutput += `${counter},${startTime},${endTime},(Sound),"${section.sound.present.replace(
            //         /"/g,
            //         '""'
            //     )}"\n`;
            //     counter++;
            // }

            // Dialogue
            if (section.text && section.speaker) {
                const row = [
                    counter,
                    `"${startTime}"`,
                    `"${endTime}"`,
                    `"${duration}"`,
                    `"${section.speaker.replace(/"/g, '""')}"`,
                    `"${section.text.replace(/"/g, '""')}"`,
                ].join(',');
                dialogOutput.push(row);
                counter++;
            }
        });
        const csvRows = dialogOutput.join('\r\n');

        // Trigger CSV download
        const blob = new Blob([csvRows], {
            type: 'text/csv;charset=utf-8;',
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.setAttribute('href', url);
        const splitFileName = this.fileName.split('.');
        link.setAttribute('download', `${splitFileName[0]}_DIALOG_SHEET.csv`);
        link.click();
    }

    generateSrt() {
        let srtOutput = ''; // Initialize SRT output
        const useBrackets = this.speaker === '[]'; // Check selected speaker option
        let counter = 1; // SRT sequence counter
        console.log('this.transcriptionSections', this.transcriptionSections);

        this.transcriptionSections.forEach((section: any) => {
            // Generate start and end timestamps in SRT format
            const startTime = this.formatTimestamp(section.start);
            const endTime = this.formatTimestamp(section.end);

            // const words = section.text.split(' ');

            // words.map((word: string) => {
            //     const isCorrect = this.dictionary.check(word);

            //     if (!isCorrect) {
            //         const suggestions = this.dictionary.suggest(word);
            //         console.log('suggestions', suggestions);
            //     }
            // });

            // this.dictionary.check('helo');

            // console.log('words>>>>>>>', words);

            //! These checks may not be relevant for OCR - Injozi

            // Handle sections with sound
            // if (section.sound?.present) {
            //     srtOutput += `${counter}\n`;
            //     srtOutput += `${startTime} --> ${endTime}\n`;
            //     srtOutput += useBrackets
            //         ? ` (${section.sound.present})\n\n`
            //         : ` [${section.sound.present}]\n\n`;
            //     counter++;
            // }

            // Handle sections with text and speaker
            // if (section.text && section.speaker) {
            //     srtOutput += `${counter}\n`;
            //     srtOutput += `${startTime} --> ${endTime}\n`;
            //     srtOutput += useBrackets
            //         ? `[${section.speaker}]: ${section.text}\n\n`
            //         : `(${section.speaker}): ${section.text}\n\n`;
            //     counter++;
            // }

            if (section.text) {
                srtOutput += `${counter}\n`;
                srtOutput += `${startTime} --> ${endTime}\n`;
                srtOutput += `${section.text}\n\n`;
                // srtOutput += useBrackets
                //     ? `[${section.speaker}]: ${section.text}\n\n`
                //     : `(${section.speaker}): ${section.text}\n\n`;
                counter++;
            }
        });

        console.log('Generated SRT:\n', srtOutput);

        // Optional: You can download the generated SRT file
        this.downloadSrt(srtOutput, 'srt');
    }

    // Helper method to format timestamps for SRT
    formatTimestamp(seconds: number): string {
        const hrs = Math.floor(seconds / 3600);
        const mins = Math.floor((seconds % 3600) / 60);
        const secs = Math.floor(seconds % 60);
        const millis = Math.floor((seconds % 1) * 1000);

        return `${hrs.toString().padStart(2, '0')}:${mins
            .toString()
            .padStart(2, '0')}:${secs.toString().padStart(2, '0')},${millis
            .toString()
            .padStart(3, '0')}`;
    }

    downloadSrt(content: any, srtType: string) {
        let blob: Blob;

        console.log('HELLO>>>>>', content);

        // For STL files, content should already be a Blob from responseType: 'blob'
        // For SRT files (text), create text blob
        if (srtType === 'stl') {
            // Content is already a blob from responseType: 'blob', use it directly
            blob =
                content instanceof Blob
                    ? content
                    : new Blob([content], { type: 'application/octet-stream' });
        } else {
            // For text formats like SRT
            blob =
                content instanceof Blob
                    ? content
                    : new Blob([content], { type: 'text/plain;charset=utf-8' });
        }

        const splitFileName = this.fileName.split('.');

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${splitFileName[0]}.${srtType}`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
    }

    // Helper method to download the SRT file
    // downloadSrt(content: any, srtType: string) {
    //     const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
    //     const url = window.URL.createObjectURL(blob);
    //     const a = document.createElement('a');
    //     a.href = url;
    //     a.download = `subtitles.${srtType}`;
    //     a.click();
    //     window.URL.revokeObjectURL(url);
    // }

    async changeLanguage(event: Event) {
        this.loader.show();

        try {
            const selectedLanguage = (event.target as HTMLSelectElement).value;
            console.log('Selected Language:', selectedLanguage);

            // if (selectedLanguage === 'en') {
            //     window.location.reload();
            //     return;
            // }
            console.log(
                'Transcription sections >>>>>>',
                this.transcriptionSections
            );

            // TODO: ADD Relevant Dictionary for given language

            switch (selectedLanguage) {
                case 'hi':
                    {
                        // this.dictionary = new Typo('hi_IN', undefined, undefined);
                        const affPath = 'assets/dictionaries/hi_IN/hi_IN.aff';
                        const dicPath = 'assets/dictionaries/hi_IN/hi_IN.dic';

                        const [affData, dicData] = await Promise.all([
                            firstValueFrom(
                                this.http.get(affPath, { responseType: 'text' })
                            ),
                            firstValueFrom(
                                this.http.get(dicPath, { responseType: 'text' })
                            ),
                        ]);

                        this.dictionary = new Typo(
                            'hi_IN',
                            affData!,
                            dicData!,
                            {
                                platform: 'any',
                            }
                        );
                    }
                    break;
                case 'zh-CN':
                    {
                        const affPath = 'assets/dictionaries/zh-CN/zh-CN.aff';
                        const dicPath = 'assets/dictionaries/zh-CN/zh-CN.dic';

                        const [affData, dicData] = await Promise.all([
                            firstValueFrom(
                                this.http.get(affPath, { responseType: 'text' })
                            ),
                            firstValueFrom(
                                this.http.get(dicPath, { responseType: 'text' })
                            ),
                        ]);

                        this.dictionary = new Typo(
                            'hi_IN',
                            affData!,
                            dicData!,
                            {
                                platform: 'any',
                            }
                        );
                    }

                    break;
                case 'ko':
                    {
                        const affPath = 'assets/dictionaries/ko/ko.aff';
                        const dicPath = 'assets/dictionaries/ko/ko.dic';

                        const [affData, dicData] = await Promise.all([
                            firstValueFrom(
                                this.http.get(affPath, { responseType: 'text' })
                            ),
                            firstValueFrom(
                                this.http.get(dicPath, { responseType: 'text' })
                            ),
                        ]);

                        this.dictionary = new Typo('ko', affData!, dicData!, {
                            platform: 'any',
                        });
                    }
                    break;
                case 'es':
                    {
                        const affPath = 'assets/dictionaries/es/es.aff';
                        const dicPath = 'assets/dictionaries/es/es.dic';

                        const [affData, dicData] = await Promise.all([
                            firstValueFrom(
                                this.http.get(affPath, { responseType: 'text' })
                            ),
                            firstValueFrom(
                                this.http.get(dicPath, { responseType: 'text' })
                            ),
                        ]);

                        this.dictionary = new Typo('es', affData!, dicData!, {
                            platform: 'any',
                        });
                    }
                    break;
                case 'fr':
                    {
                        const affPath = 'assets/dictionaries/fr/fr.aff';
                        const dicPath = 'assets/dictionaries/fr/fr.dic';

                        const [affData, dicData] = await Promise.all([
                            firstValueFrom(
                                this.http.get(affPath, { responseType: 'text' })
                            ),
                            firstValueFrom(
                                this.http.get(dicPath, { responseType: 'text' })
                            ),
                        ]);

                        this.dictionary = new Typo('fr', affData!, dicData!, {
                            platform: 'any',
                        });
                    }
                    break;
                case 'ja':
                    {
                        const affPath = 'assets/dictionaries/ja/ja_JP.aff';
                        const dicPath = 'assets/dictionaries/ja/ja_JP.dic';

                        const [affData, dicData] = await Promise.all([
                            firstValueFrom(
                                this.http.get(affPath, { responseType: 'text' })
                            ),
                            firstValueFrom(
                                this.http.get(dicPath, { responseType: 'text' })
                            ),
                        ]);

                        this.dictionary = new Typo('ja', affData!, dicData!, {
                            platform: 'any',
                        });
                    }
                    break;
                case 'pt':
                    {
                        const affPath = 'assets/dictionaries/pt/pt.aff';
                        const dicPath = 'assets/dictionaries/pt/pt.dic';

                        const [affData, dicData] = await Promise.all([
                            firstValueFrom(
                                this.http.get(affPath, { responseType: 'text' })
                            ),
                            firstValueFrom(
                                this.http.get(dicPath, { responseType: 'text' })
                            ),
                        ]);

                        this.dictionary = new Typo('pt', affData!, dicData!, {
                            platform: 'any',
                        });
                    }
                    break;
                case 'it':
                    {
                        const affPath = 'assets/dictionaries/it/it.aff';
                        const dicPath = 'assets/dictionaries/it/it.dic';

                        const [affData, dicData] = await Promise.all([
                            firstValueFrom(
                                this.http.get(affPath, { responseType: 'text' })
                            ),
                            firstValueFrom(
                                this.http.get(dicPath, { responseType: 'text' })
                            ),
                        ]);

                        this.dictionary = new Typo('it', affData!, dicData!, {
                            platform: 'any',
                        });
                    }
                    break;
                case 'af':
                    {
                        const affPath = 'assets/dictionaries/af_ZA/af_ZA.aff';
                        const dicPath = 'assets/dictionaries/af_ZA/af_ZA.dic';

                        const [affData, dicData] = await Promise.all([
                            firstValueFrom(
                                this.http.get(affPath, { responseType: 'text' })
                            ),
                            firstValueFrom(
                                this.http.get(dicPath, { responseType: 'text' })
                            ),
                        ]);

                        this.dictionary = new Typo(
                            'af_ZA',
                            affData!,
                            dicData!,
                            {
                                platform: 'any',
                            }
                        );
                    }
                    break;
                case 'en':
                    {
                        window.location.reload();
                    }
                    break;
            }

            const translatedJson = await this.translateChunkOptimized2(
                this.originalTranscriptionSections,
                this.language,
                selectedLanguage
            );

            translatedJson.forEach((section: any) => {
                // 1. Replace "\n" sequences with real line breaks
                const sentence = (section.text || '').replace(/\\n/g, '\n');

                // 2. Split into words + whitespace (preserve spaces and newlines)
                const tokens = sentence.split(/(\s+)/);

                // 3. Highlight only real words
                const highlightedTokens = tokens.map((token: string) => {
                    // Skip whitespace (spaces, tabs, newlines)
                    if (/^\s+$/.test(token)) {
                        return token;
                    }

                    const cleaned = token.replace(/[^\p{L}\p{N}']/gu, '');

                    if (!cleaned) return token;

                    const isCorrect = this.dictionary.check(cleaned);
                    if (!isCorrect) {
                        // TODO: Store suggestions for potential future use
                        // const suggestions =
                        //     this.dictionary.suggest(cleaned);
                        // console.log('suggestions', suggestions);
                    }
                    return isCorrect
                        ? token
                        : `<span class="error">${token}</span>`;
                });

                // 4. Join tokens back (whitespace preserved)
                section.processedText = this.sanitizer.bypassSecurityTrustHtml(
                    highlightedTokens.join('')
                );
            });
            // this.runSpellCheck(translatedJson);

            // Ensure `transcriptionSections` is an array
            this.transcriptionSections = Array.isArray(translatedJson)
                ? translatedJson
                : [translatedJson];
            this.language = selectedLanguage;
        } catch (error) {
            console.error('Error in changeLanguage:', error);
        } finally {
            this.loader.hide();
        }
    }

    // !Latest solution - compromise between chunking and seperated values
    async translateChunkOptimized2(json: any[], lang: string, tlang: string) {
        const chunkSize = 20;

        const escapeHtml = (s: string) =>
            s
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#39;');

        const htmlToPlain = (html: string) => {
            const withNewlines = html.replace(/<br\s*\/?>/gi, '\n');
            const noTags = withNewlines.replace(/<\/?[^>]+(>|$)/g, '');
            return noTags
                .replace(/&amp;/g, '&')
                .replace(/&lt;/g, '<')
                .replace(/&gt;/g, '>')
                .replace(/&quot;/g, '"')
                .replace(/&#39;/g, "'");
        };

        const chunks: any[][] = [];
        for (let i = 0; i < json.length; i += chunkSize) {
            chunks.push(json.slice(i, i + chunkSize));
        }

        const translatedChunks = await Promise.all(
            chunks.map(async (chunk) => {
                // wrap each text with <seg id="..."> ... </seg>
                const htmlCombined = chunk
                    .map((seg: any) => {
                        const id = String(seg.index ?? '');
                        const txt = escapeHtml(
                            String(seg.text ?? '') + `<!--${id}-->`
                        );
                        return `<seg id="${id}">${txt}</seg>`;
                    })
                    .join('');

                let translatedCombined: string;
                try {
                    // ✅ use 3-arg signature only
                    translatedCombined = await this.translator.translateText(
                        htmlCombined,
                        tlang,
                        lang
                    );
                } catch (e) {
                    console.warn(
                        'Chunk translation failed — returning original chunk as fallback',
                        e
                    );
                    return chunk;
                }

                // parse back <seg id="...">...</seg>
                const regex = /<seg\s+id="([^"]+)">([\s\S]*?)<\/seg>/g;
                const map = new Map<string, { html: string; plain: string }>();
                let match: RegExpExecArray | null;
                while ((match = regex.exec(translatedCombined)) !== null) {
                    const id = match[1];
                    let innerHtml = match[2];
                    innerHtml = innerHtml
                        .replace(
                            /^\s*(?:<!---?\s*\d+\s*-->|--\s*\d+\s*-->)\s*/,
                            ''
                        )
                        .replace(
                            /\s*(?:<!---?\s*\d+\s*-->|--\s*\d+\s*-->)\s*$/,
                            ''
                        )
                        .trim();

                    map.set(id, {
                        html: innerHtml,
                        plain: htmlToPlain(innerHtml),
                    });
                }

                return chunk.map((seg: any, idx: number) => {
                    const idxNum =
                        typeof seg.index === 'number'
                            ? seg.index
                            : parseInt(
                                  String(seg.index).replace(/[^\d]/g, ''),
                                  10
                              ) || idx + 1;

                    const key = String(seg.index ?? idxNum);
                    const found = map.get(key);

                    const translatedPlain =
                        found?.plain ?? String(seg.text ?? '');
                    const translatedHtml =
                        found?.html ??
                        String(
                            seg.processedText
                                ?.changingThisBreaksApplicationSecurity ?? ''
                        ).replace(/\n/g, '<br/>');

                    return {
                        ...seg,
                        index: idxNum,
                        text: translatedPlain,
                        processedText: {
                            changingThisBreaksApplicationSecurity:
                                translatedHtml,
                        },
                        sound: 'ddl',
                    };
                });
            })
        );

        return translatedChunks.flat();
    }

    // ! Viable but hits translate api on every line!
    // async translateChunkOptimized2(json: any[], lang: string, tlang: string) {
    //     const chunkSize = 20;
    //     const maxConcurrent = 5; // tweak if you hit AWS throttling

    //     type Segment = {
    //         index: number;
    //         start: number;
    //         end: number;
    //         text: string;
    //         processedText: SafeHtml;
    //         [k: string]: any;
    //     };

    //     // Small concurrency runner
    //     async function runWithConcurrency<T, R>(
    //         items: T[],
    //         worker: (item: T, idx: number) => Promise<R>,
    //         concurrency: number
    //     ): Promise<R[]> {
    //         const results: R[] = new Array(items.length);
    //         let i = 0;
    //         const workers = Array.from(
    //             { length: Math.min(concurrency, items.length) },
    //             async () => {
    //                 while (i < items.length) {
    //                     const cur = i++;
    //                     results[cur] = await worker(items[cur], cur);
    //                 }
    //             }
    //         );
    //         await Promise.all(workers);
    //         return results;
    //     }

    //     const output: Segment[] = [];

    //     for (let i = 0; i < json.length; i += chunkSize) {
    //         const chunk: Segment[] = json.slice(i, i + chunkSize);

    //         // Translate each segment.text individually (in parallel with a cap)
    //         const translatedTexts = await runWithConcurrency(
    //             chunk,
    //             async (seg) => {
    //                 const text = seg?.text ?? '';
    //                 if (!text) return text;
    //                 try {
    //                     const translated = await this.translator.translateText(
    //                         text,
    //                         tlang,
    //                         lang
    //                     );
    //                     return translated ?? text; // fallback if empty
    //                 } catch (e) {
    //                     console.warn(
    //                         'Translate error for index',
    //                         seg?.index,
    //                         e
    //                     );
    //                     return text; // fallback to original
    //                 }
    //             },
    //             maxConcurrent
    //         );

    //         // Assign back, normalize index to a number, keep everything else as-is
    //         for (let k = 0; k < chunk.length; k++) {
    //             const seg = chunk[k];
    //             // Normalize index to a pure number (strip non-digits if needed)
    //             let idxNum: number;
    //             if (typeof seg.index === 'number') {
    //                 idxNum = seg.index;
    //             } else {
    //                 const parsed = parseInt(
    //                     String(seg.index).replace(/[^\d]/g, ''),
    //                     10
    //                 );
    //                 idxNum = Number.isFinite(parsed) ? parsed : i + k + 1;
    //             }

    //             output.push({
    //                 ...seg,
    //                 index: idxNum,
    //                 text: translatedTexts[k] ?? seg.text,
    //             });
    //         }
    //     }

    //     console.log('translated text output>>>>>', output);

    //     return output;
    // }

    //!Original chunking solution
    // async translateChunkOptimized2(json: any[], lang: string, tlang: string) {
    //     const chunkSize = 20;

    //     type Segment = {
    //         index: number;
    //         start: number;
    //         end: number;
    //         text: string;
    //         processedText: SafeHtml;
    //     };

    //     // Split JSON into chunks
    //     const chunks: Segment[][] = [];
    //     for (let i = 0; i < json.length; i += chunkSize) {
    //         chunks.push(json.slice(i, i + chunkSize));
    //     }

    //     const translatedChunks = await Promise.all(
    //         chunks.map(async (chunk) => {
    //             const flattened = this.flattenJson(chunk);

    //             const keysToTranslate = Object.keys(flattened).filter(
    //                 (key) =>
    //                     !key.endsWith('.start') &&
    //                     !key.endsWith('.end') &&
    //                     !key.endsWith('.index') && // ✅ do not translate index
    //                     !key.endsWith('.speaker') &&
    //                     !key.endsWith(
    //                         '.processedText.changingThisBreaksApplicationSecurity'
    //                     )
    //             );

    //             const valuesToTranslate = keysToTranslate
    //                 .map((key) => flattened[key])
    //                 .join('\n');

    //             const translatedValuesString =
    //                 await this.translator.translateText(
    //                     valuesToTranslate,
    //                     tlang,
    //                     lang
    //                 );

    //             const translatedValues = translatedValuesString.split('\n');

    //             // Map translations back
    //             keysToTranslate.forEach((key, index) => {
    //                 flattened[key] = translatedValues[index];
    //             });

    //             // ✅ Ensure index stays original
    //             Object.keys(flattened).forEach((key) => {
    //                 if (
    //                     key.endsWith('.index') &&
    //                     typeof flattened[key] !== 'number'
    //                 ) {
    //                     // restore original index if overwritten
    //                     const pathParts = key.split('.');
    //                     const itemIdx = parseInt(pathParts[0], 10);
    //                     flattened[key] = chunk[itemIdx].index;
    //                 }
    //             });

    //             // ✅ Always reconstruct as array
    //             const reconstructed = this.reconstructJson(
    //                 flattened,
    //                 Object.values(flattened)
    //             );
    //             return Array.isArray(reconstructed)
    //                 ? reconstructed
    //                 : Object.values(reconstructed);
    //         })
    //     );

    //     console.log('translated chunks json', translatedChunks.flat());

    //     // ✅ Merge all translated chunks into one array
    //     return translatedChunks.flat();
    // }

    async translateChunkOptimzed(json: any[], lang: string, tlang: string) {
        const chunkSize = 20;

        type Segment = {
            index: number;
            start: number;
            end: number;
            text: string;
            processedText: SafeHtml;
        };

        // Split JSON into chunks of 20
        const chunks: Segment[][] = [];
        for (let i = 0; i < json.length; i += chunkSize) {
            chunks.push(json.slice(i, i + chunkSize));
        }

        // Translate each chunk in parallel
        const translatedChunks = await Promise.all(
            chunks.map(async (chunk) => {
                const flattened = this.flattenJson(chunk);

                const keysToTranslate = Object.keys(flattened).filter(
                    (key) =>
                        !key.endsWith('.start') &&
                        !key.endsWith('.end') &&
                        !key.endsWith('.speaker') &&
                        !key.endsWith(
                            '.processedText.changingThisBreaksApplicationSecurity'
                        )
                );

                const valuesToTranslate = keysToTranslate
                    .map((key) => flattened[key])
                    .join('\n');

                // Call AWS translation
                const translatedValuesString =
                    await this.translator.translateText(
                        valuesToTranslate,
                        tlang,
                        lang
                    );

                const translatedValues = translatedValuesString.split('\n');

                // Reassign translations back into flattened structure
                keysToTranslate.forEach((key, index) => {
                    flattened[key] = translatedValues[index];
                });

                // Reconstruct the original chunk
                return this.reconstructJson(
                    flattened,
                    Object.values(flattened)
                );
            })
        );

        // Merge back into a single array
        console.log('Translated chunks optimized', translatedChunks.flat());
        return translatedChunks.flat();
    }

    async translateChunck(json: any, lang: any, tlang: any) {
        let chunkArray: any = [];
        type Segment = {
            index: number;
            start: number;
            end: number;
            text: string;
            processedText: SafeHtml;
        };
        let chunkSize = 20;

        const chuncks = json.reduce(
            (acc: Segment[][], _: Segment, index: number) => {
                if (index % chunkSize === 0) {
                    acc.push(json.slice(index, index + chunkSize));
                }
                return acc;
            },
            [] as Segment[][]
        );

        console.log('Chunks >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>', chuncks);

        chuncks.forEach((chunk: Segment) => {
            const flattened = this.flattenJson(chunk);
            const keysToTranslate = Object.keys(flattened).filter(
                (key) =>
                    !key.endsWith('.start') &&
                    !key.endsWith('.end') &&
                    !key.endsWith('.speaker') &&
                    !key.endsWith(
                        '.processedText.changingThisBreaksApplicationSecurity'
                    )
            );

            const valuesToTranslate = keysToTranslate
                .map((key) => flattened[key])
                .join('\n');

            // const translatedValuesString = this.translator.translateText(
            //     valuesToTranslate,
            //     tlang,
            //     lang
            // );

            // console.log(
            //     'Translate Chunks >>>>>>>>>>>>>>>',
            //     translatedValuesString
            // );

            this.translator
                .translateText(valuesToTranslate, tlang, lang)
                .then((translatedValuesString) => {
                    console.log(
                        'Translate Chunks >>>>>>>>>>>>>>>',
                        translatedValuesString
                    );
                    chunkArray.push(translatedValuesString);
                    console.log('CHUNK ARRAY >>>>>>>>>>>>>>>>>>', chunkArray);
                    chunkArray.forEach((chunk: string) => {
                        chunk.split('\n');
                    });
                })
                .catch((error) => {
                    console.error('Translation error:', error);
                });

            keysToTranslate.forEach((key, index) => {
                flattened[key] = chunkArray[index];
            });

            const reconstructedJson = this.reconstructJson(
                flattened,
                Object.values(flattened)
            );

            // Ensure the result is an array if the input is an array
            if (Array.isArray(json)) {
                return Object.values(reconstructedJson); // Convert back to array
            }

            console.log(
                'Reconstructed json )))))))))))))))))))))))))))',
                reconstructedJson
            );

            return reconstructedJson;

            // const translatedValues = translatedValuesString.split('\n');
        });

        // const flattened = this.flattenJson(json);

        // console.log('Json that gets translated -flattened', flattened);

        // Filter out keys that should not be translated (e.g., "speaker")
        // const keysToTranslate = Object.keys(flattened).filter(
        //     (key) =>
        //         !key.endsWith('.start') &&
        //         !key.endsWith('.end') &&
        //         !key.endsWith('.speaker') &&
        //         !key.endsWith(
        //             '.processedText.changingThisBreaksApplicationSecurity'
        //         )
        // );

        // // Extract values for translation
        // const valuesToTranslate = keysToTranslate
        //     .map((key) => flattened[key])
        //     .join('\n');

        // console.log('Values that get translated', valuesToTranslate);

        // // Translate the filtered values in one API call
        // const translatedValuesString = await this.translator.translateText(
        //     valuesToTranslate,
        //     tlang,
        //     lang
        // );

        // const translatedValues = translatedValuesString.split('\n');
    }

    async translateWholeJson(json: any, lang: any, tlang: any): Promise<any> {
        try {
            // Flatten the JSON structure to isolate values
            const flattened = this.flattenJson(json);

            console.log('Json that gets translated -flattened', flattened);

            // Filter out keys that should not be translated (e.g., "speaker")
            const keysToTranslate = Object.keys(flattened).filter(
                (key) =>
                    !key.endsWith('.start') &&
                    !key.endsWith('.end') &&
                    !key.endsWith('.speaker') &&
                    !key.endsWith(
                        '.processedText.changingThisBreaksApplicationSecurity'
                    )
            );

            // Extract values for translation
            const valuesToTranslate = keysToTranslate
                .map((key) => flattened[key])
                .join('\n');

            console.log('Values that get translated', valuesToTranslate);

            // Translate the filtered values in one API call
            const translatedValuesString = await this.translator.translateText(
                valuesToTranslate,
                tlang,
                lang
            );

            const translatedValues = translatedValuesString.split('\n');

            const splitValues = translatedValues.slice(0, 5);

            // console.log(splitValues, 'Split Values >>>>>>>');

            // console.log('Translate ><><><><><><><><', translatedValues);

            // Reconstruct the JSON with translated values
            keysToTranslate.forEach((key, index) => {
                flattened[key] = translatedValues[index];
            });

            // keysToTranslate.forEach((key, index) => {
            //     flattened[key] = splitValues[index];
            // });

            // Reconstruct the original JSON structure
            const reconstructedJson = this.reconstructJson(
                flattened,
                Object.values(flattened)
            );

            // Ensure the result is an array if the input is an array
            if (Array.isArray(json)) {
                return Object.values(reconstructedJson); // Convert back to array
            }

            return reconstructedJson;
        } catch (error) {
            console.error('Error translating JSON in one API call:', error);
            throw error; // Propagate the error
        }
    }

    private flattenJson(
        obj: any,
        parentKey: string = '',
        result: any = {}
    ): any {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                const newKey = parentKey ? `${parentKey}.${key}` : key;
                if (typeof obj[key] === 'object' && obj[key] !== null) {
                    this.flattenJson(obj[key], newKey, result);
                } else {
                    result[newKey] = obj[key];
                }
            }
        }
        return result;
    }

    private reconstructJson(flattened: any, translatedValues: string[]): any {
        const keys = Object.keys(flattened);
        const reconstructed: any = Array.isArray(flattened) ? [] : {}; // Ensure correct type (array or object)

        keys.forEach((key, index) => {
            const keysArray = key.split('.');
            keysArray.reduce((acc, curr, i) => {
                if (i === keysArray.length - 1) {
                    acc[curr] = translatedValues[index];
                } else {
                    acc[curr] =
                        acc[curr] ||
                        (isNaN(Number(keysArray[i + 1])) ? {} : []); // Handle arrays properly
                }
                return acc[curr];
            }, reconstructed);
        });

        return reconstructed;
    }

    async changePunctuation(event: Event): Promise<void> {
        this.loader.show();
        try {
            // Get the punctuation type (add/remove)
            this.Punctuation = +(event.target as HTMLSelectElement).value;
            const command =
                this.Punctuation === 1
                    ? 'Add proper punctuation to the sentence.'
                    : 'Remove all punctuation from the sentence.';

            // Extract all `text` fields to process
            const textsToProcess: {
                index: number;
                text: string;
                start: number;
                end: number;
            }[] = this.transcriptionSections
                .map(
                    (
                        section: { text?: string; start: number; end: number },
                        index: number
                    ) => ({
                        index,
                        text: section.text || '', // Ensure `text` is a string or empty string
                        start: section.start, // Preserve start time
                        end: section.end, // Preserve end time
                    })
                )
                .filter((item: { text: string }) => item.text); // Filter out sections without `text`

            if (!textsToProcess.length) {
                console.warn('No texts to process for punctuation.');
                return;
            }

            // Process all texts in parallel
            const processedTexts = await Promise.allSettled(
                textsToProcess.map(async (item) => {
                    try {
                        const processedText = await this.processTextWithChatGPT(
                            item.text,
                            command
                        );
                        return {
                            index: item.index,
                            text: processedText.trim(),
                            start: item.start,
                            end: item.end,
                        };
                    } catch (error) {
                        console.error(
                            `Error processing text at index ${item.index}:`,
                            error
                        );
                        return {
                            index: item.index,
                            text: item.text, // Keep the original text if processing fails
                            start: item.start,
                            end: item.end,
                        };
                    }
                })
            );

            // Update the original JSON structure with the processed texts
            processedTexts.forEach((result, idx) => {
                if (result.status === 'fulfilled') {
                    const { index, text, start, end } = result.value;
                    this.transcriptionSections[index].text = text; // Update with processed text
                    this.transcriptionSections[index].start = start; // Preserve start time
                    this.transcriptionSections[index].end = end; // Preserve end time
                } else {
                    console.error(
                        `Error in processing text at index ${textsToProcess[idx].index}:`,
                        result.reason
                    );
                    // Keep the original text in case of failure
                    const { index, text, start, end } = textsToProcess[idx];
                    this.transcriptionSections[index].text = text; // Keep the original text
                    this.transcriptionSections[index].start = start; // Preserve start time
                    this.transcriptionSections[index].end = end; // Preserve end time
                }
            });

            console.log(
                'Updated transcriptionSections:',
                this.transcriptionSections
            );
        } catch (error) {
            console.error('Error in changePunctuation:', error);
        } finally {
            this.loader.hide();
        }
    }

    // async changePunctuation(event: Event): Promise<void> {
    //   this.loader.show();
    //   try {
    //     // Get the punctuation type (add/remove)
    //     this.Punctuation = +(event.target as HTMLSelectElement).value;
    //     const command =
    //       this.Punctuation === 1
    //         ? "For each sentence, add proper punctuation. Preserve the order, and return the result line by line."
    //         : "For each sentence, remove all punctuation. Preserve the order, and return the result line by line.";

    //     // Extract all `text` fields to process
    //     const textsToProcess: { index: number; text: string; start: number; end: number }[] =
    //       this.transcriptionSections
    //         .map((section: { text?: string; start: number; end: number }, index: number) => ({
    //           index,
    //           text: section.text || "", // Ensure `text` is a string or empty string
    //           start: section.start, // Preserve start time
    //           end: section.end,     // Preserve end time
    //         }))
    //         .filter((item: { text: string }) => item.text); // Filter out sections without `text`

    //     if (!textsToProcess.length) {
    //       console.warn("No texts to process for punctuation.");
    //       return;
    //     }

    //     // Process each text individually to match the response structure
    //     for (const item of textsToProcess) {
    //       try {
    //         // Call the API for the individual text
    //         const processedText = await this.processTextWithChatGPT(item.text, command);

    //         // Update the original JSON structure with the processed text
    //         this.transcriptionSections[item.index].text = processedText.trim();
    //         this.transcriptionSections[item.index].start = item.start; // Ensure start time remains unchanged
    //         this.transcriptionSections[item.index].end = item.end;     // Ensure end time remains unchanged
    //       } catch (error) {
    //         console.error(`Error processing text at index ${item.index}:`, error);
    //       }
    //     }

    //     console.log("Updated transcriptionSections:", this.transcriptionSections);
    //   } catch (error) {
    //     console.error("Error in changePunctuation:", error);
    //   } finally {
    //     this.loader.hide();
    //   }
    // }

    async changeTense(event: Event): Promise<void> {
        this.loader.show();
        try {
            // Get the selected tense type
            this.Tense = +(event.target as HTMLSelectElement).value;

            // Define the appropriate command based on the selected tense
            const command =
                this.Tense === 1
                    ? 'Convert the sentence into Present Tense.'
                    : 'Convert the sentence into Present Participle Tense.';

            // Extract all `text` fields to process
            const textsToProcess: {
                index: number;
                text: string;
                start: number;
                end: number;
            }[] = this.transcriptionSections
                .map(
                    (
                        section: { text?: string; start: number; end: number },
                        index: number
                    ) => ({
                        index,
                        text: section.text || '', // Ensure `text` is a string or empty string
                        start: section.start, // Preserve start time
                        end: section.end, // Preserve end time
                    })
                )
                .filter((item: { text: string }) => item.text); // Filter out sections without `text`

            if (!textsToProcess.length) {
                console.warn('No texts to process for tense conversion.');
                return;
            }

            // Process texts in parallel
            const processedTexts = await Promise.allSettled(
                textsToProcess.map(async (item) => {
                    try {
                        const processedText = await this.processTextWithChatGPT(
                            item.text,
                            command
                        );
                        return {
                            index: item.index,
                            text: processedText.trim(),
                            start: item.start,
                            end: item.end,
                        };
                    } catch (error) {
                        console.error(
                            `Error processing text at index ${item.index}:`,
                            error
                        );
                        return {
                            index: item.index,
                            text: item.text, // Keep the original text if processing fails
                            start: item.start,
                            end: item.end,
                        };
                    }
                })
            );

            // Update the original JSON structure with the processed texts
            processedTexts.forEach((result, idx) => {
                if (result.status === 'fulfilled') {
                    const { index, text, start, end } = result.value;
                    this.transcriptionSections[index].text = text; // Update with processed text
                    this.transcriptionSections[index].start = start; // Preserve start time
                    this.transcriptionSections[index].end = end; // Preserve end time
                } else {
                    console.error(
                        `Error in processing text at index ${textsToProcess[idx].index}:`,
                        result.reason
                    );
                    // Keep the original text in case of failure
                    const { index, text, start, end } = textsToProcess[idx];
                    this.transcriptionSections[index].text = text; // Keep the original text
                    this.transcriptionSections[index].start = start; // Preserve start time
                    this.transcriptionSections[index].end = end; // Preserve end time
                }
            });

            console.log(
                'Updated transcriptionSections:',
                this.transcriptionSections
            );
        } catch (error) {
            console.error('Error in changeTense:', error);
        } finally {
            this.loader.hide();
        }
    }

    async processTextWithChatGPT(
        text: string,
        command: string
    ): Promise<string> {
        try {
            const payload = { command, text };
            const response = await (
                await this.userService.getOpenAi(
                    command,
                    JSON.stringify(payload)
                )
            ).toPromise();

            // Extract the processed text from the response
            const processedText = response?.data?.message?.content?.trim();
            if (!processedText) {
                throw new Error(
                    'API response does not contain processed text.'
                );
            }
            return processedText;
        } catch (error) {
            console.error('Error in processTextWithChatGPT:', error);
            throw error; // Re-throw or handle the error as needed
        }
    }
}
